import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Chart as ChartJS, registerables } from 'chart.js';
import { CloseButton } from 'components/common/Toast';
import SettingsPanel from 'components/settings-panel/SettingsPanel';
import { useAppContext } from 'providers/AppProvider';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import ua from './utils/detectUserAgent';

ChartJS.register(...registerables);

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition },
  } = useAppContext();

  useEffect(() => {
    if (ua.windows()) document.documentElement.classList.add('windows');
    if (ua.chrome()) document.documentElement.classList.add('chrome');
    if (ua.firefox()) document.documentElement.classList.add('firefox');
    if (ua.safari()) document.documentElement.classList.add('safari');
  }, []);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition, HTMLClassList]);

  return (
    <>
      <Outlet />
      {/*<SettingsToggle />*/}
      <SettingsPanel />
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position="bottom-left"
      />
    </>
  );
};

export default App;
